import { render, staticRenderFns } from "./NavStaff.vue?vue&type=template&id=66b84540&scoped=true&"
import script from "./NavStaff.vue?vue&type=script&lang=js&"
export * from "./NavStaff.vue?vue&type=script&lang=js&"
import style0 from "./NavStaff.vue?vue&type=style&index=0&id=66b84540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b84540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
